import React, { useCallback, useEffect, useState } from 'react';
import { sharedState, } from '../../../store/rxjs/shared-state';
import { ERC20BridgeDialog } from '../ERC20BridgeDialog/ERC20BridgeDialog';
import { EmailNotificationSettingsDialog } from '../EmailNotificationSettingsDialog/EmailNotificationSettingsDialog';
import { RuneBridgeDialog } from '../RuneBridgeDialog/RuneBridgeDialog';
export const SharedStateProvider = ({ children, }) => {
    const [runeBridgeDialog, setRuneBridgeDialog] = useState(sharedState.get().runeBridgeDialog);
    const [erc20BridgeDialog, setErc20BridgeDialog] = useState(sharedState.get().erc20BridgeDialog);
    const [emailNotificationSettingsDialog, setEmailNotificationSettingsDialog] = useState(sharedState.get().emailNotificationSettingsDialog);
    useEffect(() => {
        const emailNotificationSettingsDialogSubscription = sharedState
            .select('emailNotificationSettingsDialog')
            .subscribe(setEmailNotificationSettingsDialog);
        return () => {
            emailNotificationSettingsDialogSubscription.unsubscribe();
        };
    }, []);
    useEffect(() => {
        const runeBridgeDialogSubscription = sharedState
            .select('runeBridgeDialog')
            .subscribe(setRuneBridgeDialog);
        return () => {
            runeBridgeDialogSubscription.unsubscribe();
        };
    }, []);
    useEffect(() => {
        const erc20BridgeDialogSubscription = sharedState
            .select('erc20BridgeDialog')
            .subscribe(setErc20BridgeDialog);
        return () => {
            erc20BridgeDialogSubscription.unsubscribe();
        };
    }, []);
    const handleEmailNotificationSettingsDialogClose = useCallback(() => sharedState.actions.closeEmailNotificationSettingsDialog(), []);
    const handleRuneBridgeDialogClose = useCallback(() => sharedState.actions.closeRuneBridgeDialog(), []);
    const handleErc20BridgeDialogClose = useCallback(() => sharedState.actions.closeErc20BridgeDialog(), []);
    return (React.createElement(React.Fragment, null,
        children,
        React.createElement(EmailNotificationSettingsDialog, { isOpen: emailNotificationSettingsDialog.isOpen, onClose: handleEmailNotificationSettingsDialogClose }),
        React.createElement(RuneBridgeDialog, { isOpen: runeBridgeDialog.isOpen, onClose: handleRuneBridgeDialogClose, step: runeBridgeDialog.step }),
        React.createElement(ERC20BridgeDialog, { isOpen: erc20BridgeDialog.isOpen, onClose: handleErc20BridgeDialogClose, step: erc20BridgeDialog.step })));
};
